import React, {useContext} from "react"
import PropTypes from "prop-types"
import * as Yup from "yup"
import {Formik, Form, Field} from "formik"

import {SelectInput, TextInput, ReCAPTCHAInput} from "../forms"
import {Button, ErrorMessage} from "../styled"
import {QuestionsAndContactComponent} from "../index"
import {addOptionalReCaptchaSchema} from "../../utils/FormUtils"

import {AppContext} from "../context/AppContext"

const initialValues = {
  phoneNumber: "",
  promoCode: "",
  recaptcha: ""
}

let constantSchema = {
  phoneNumber: Yup.string().required("T-Mobile Phone Number is required"),
  promoCode: Yup.string().required("Promotion Code is required")
}

export const NewSubmissionForm = ({isLoading, onSubmit, isReCaptchaVisible}) => {
  const {state} = useContext(AppContext)
  const hasActiveAccounts = state.user.phoneNumbers.length > 0
  const validationSchema = addOptionalReCaptchaSchema(constantSchema, isReCaptchaVisible)

  return (
    <>
    {isLoading ? (<div>Loading ... </div>) :
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
        {({status, isSubmitting}) => (
          <Form>
            <p className="">Fields marked with * are required</p>
            <div className="row">
              <div className="form-group col-md-12">
                <Field name="phoneNumber" component={SelectInput} disabled={!hasActiveAccounts}>
                  <option value="">T-Mobile Phone Number*</option>
                  {state.user && state.user.phoneNumbers.map((phoneNumber) => (<option value={phoneNumber} key={phoneNumber}>{phoneNumber}</option>))}
                </Field>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-12">
                <Field name="promoCode" component={TextInput} type="text" placeholder="Promotion Code*" disabled={!hasActiveAccounts}></Field>
              </div>
            </div>
            {isReCaptchaVisible && hasActiveAccounts &&
              <div className="row">
                <div className="col-md-12">
                  <Field name="recaptcha" component={ReCAPTCHAInput} />
                </div>
              </div>
            }
            {!hasActiveAccounts &&
              <div className="row">
                <div className="col-md-12">
                  <ErrorMessage>You don&apos;t have an active T-Mobile account, or are not eligible for any promotions.</ErrorMessage>
                </div>
              </div>
            }
            <div className="row">
              <div className="col-md-12">
                <QuestionsAndContactComponent />
              </div>
            </div>
            <div className="mt-3 text-center text-md-left">
              <Button type="submit" className="btn" id="btnSubmit" primary disabled={isSubmitting || !hasActiveAccounts}>{isSubmitting ? "Searching" : "Start"}</Button>
              {status && status.formError && <ErrorMessage>{status.formError}</ErrorMessage>}
            </div>
          </Form>
        )}
      </Formik> }
    </>
  )
}

NewSubmissionForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isReCaptchaVisible: PropTypes.bool
}
